export const specializationFrag = `
    code
    name
`;
